class GwpSync extends HTMLElement {
  connectedCallback() {
    this.variantId = this.dataset.gwpVariantId;
    if (!this.variantId) return;

    this.threshold = parseInt(this.dataset.gwpThreshold, 10) || 0;
    this.subtotal = parseInt(this.dataset.gwpSubtotal, 10) || 0;
    this.inCart = this.dataset.gwpInCart === 'true';
    this.realItemCount = parseInt(this.dataset.gwpRealItemCount, 10) || 0;

    const shouldHaveGift = this.realItemCount > 0 && this.subtotal >= this.threshold;

    if (shouldHaveGift && !this.inCart) {
      this.updateCart({ [this.variantId]: 1 });
    } else if (!shouldHaveGift && this.inCart) {
      this.updateCart({ [this.variantId]: 0 });
    }
  }

  getSectionsToUpdate() {
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  updateCart(updates) {
    const sections = this.getSectionsToUpdate();
    const body = JSON.stringify({ updates, sections });

    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
      })
      .catch((error) => {
        console.error('Error syncing GWP cart item:', error);
      });
  }
}
customElements.define('gwp-sync', GwpSync);
